import { render } from "./Lax.vue?vue&type=template&id=5afb317e"
import script from "./Lax.vue?vue&type=script&lang=js"
export * from "./Lax.vue?vue&type=script&lang=js"

import "./Lax.vue?vue&type=style&index=0&id=5afb317e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__